import getApolloClient from './apolloClient'
import gql from 'graphql-tag'
// import Vue from 'vue'
const gqlFilesWay = './graphql/contracting/'

export default class ContractingApi {
  async createContract(tenderId, supplierCodes) {
    let query = await import(gqlFilesWay + 'createContract.gql')
    return (await getApolloClient('/contracting'))
      .mutate({
        mutation: gql`${query}`,
        variables: { tenderId, supplierCodes }
      })
  }
}